import { GenIcon } from '../helpers/IconBase.es.js';

const EyeHideFilled = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M11.859 8.47273L14.724 11.3364L14.7422 11.1909C14.7422 9.68182 13.5234 8.46364 12.0136 8.46364L11.859 8.47273ZM7.93906 9.18182L9.34879 10.5909C9.30332 10.7818 9.27603 10.9818 9.27603 11.1818C9.27603 12.6909 10.4948 13.9091 12.0045 13.9091C12.2046 13.9091 12.4047 13.8818 12.5957 13.8364L14.0055 15.2455C13.3961 15.5455 12.7231 15.7273 12.0045 15.7273C9.49432 15.7273 7.45703 13.6909 7.45703 11.1818C7.45703 10.4636 7.63893 9.79091 7.93906 9.18182ZM2.9095 4.15455L4.98317 6.22727L5.40155 6.64545C3.89177 7.81818 2.70941 9.38182 2 11.1818C3.57344 15.1727 7.45703 18 12.0045 18C13.4143 18 14.7603 17.7273 15.9882 17.2364L16.3702 17.6182L19.0359 20.2727L20.1901 19.1182L4.06457 3L2.9095 4.15455ZM12.0045 6.63636C14.5148 6.63636 16.5521 8.67273 16.5521 11.1818C16.5521 11.7727 16.4338 12.3273 16.2246 12.8455L18.8804 15.5C20.2538 14.3545 21.3361 12.8727 22 11.1818C20.4266 7.19091 16.543 4.36364 11.9955 4.36364C10.7221 4.36364 9.50341 4.59091 8.37563 5L10.3402 6.96364C10.8586 6.75455 11.4134 6.63636 12.0045 6.63636Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};

export { EyeHideFilled };
